module.exports = __webpack_public_path__ + "static/media/sport-et-citoyennete_3.efe109fd.jpg";